/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IssueCliTokensDto } from '../models/IssueCliTokensDto';
import type { IssueCliTokensResponseDto } from '../models/IssueCliTokensResponseDto';
import type { LogoutDto } from '../models/LogoutDto';
import type { MyUserDto } from '../models/MyUserDto';
import type { RefreshTokenDto } from '../models/RefreshTokenDto';
import type { RequestOtpDto } from '../models/RequestOtpDto';
import type { SelectBusinessDto } from '../models/SelectBusinessDto';
import type { SigninUserResponseDto } from '../models/SigninUserResponseDto';
import type { VerifyOtpDto } from '../models/VerifyOtpDto';
import type { VerifyOtpResponseDto } from '../models/VerifyOtpResponseDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthenticationService {
    /**
     * Request an OTP for authentication
     * @param requestBody
     * @returns any OTP sent successfully
     * @throws ApiError
     */
    public static authenticationControllerRequestOtpV1(
        requestBody: RequestOtpDto,
    ): CancelablePromise<{
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/authentication/otp/request',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                429: `Too many requests - rate limit exceeded`,
            },
        });
    }
    /**
     * Verify OTP and sign in
     * @param requestBody
     * @returns VerifyOtpResponseDto
     * @throws ApiError
     */
    public static authenticationControllerVerifyOtpV1(
        requestBody: VerifyOtpDto,
    ): CancelablePromise<VerifyOtpResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/authentication/otp/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                429: `Too many requests - rate limit exceeded`,
            },
        });
    }
    /**
     * Refresh access token using refresh token
     * @param requestBody
     * @returns SigninUserResponseDto
     * @throws ApiError
     */
    public static authenticationControllerRefreshTokenV1(
        requestBody: RefreshTokenDto,
    ): CancelablePromise<SigninUserResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/authentication/token/refresh',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Switch to a different business and get new tokens
     * @param requestBody
     * @returns SigninUserResponseDto
     * @throws ApiError
     */
    public static authenticationControllerSelectBusinessV1(
        requestBody: SelectBusinessDto,
    ): CancelablePromise<SigninUserResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/authentication/select-business',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Logout by revoking a refresh token
     * @param requestBody
     * @returns any Logout successful
     * @throws ApiError
     */
    public static authenticationControllerLogoutV1(
        requestBody: LogoutDto,
    ): CancelablePromise<{
        success?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/authentication/logout',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Logout from all devices by revoking all refresh tokens
     * @returns any All devices logged out
     * @throws ApiError
     */
    public static authenticationControllerLogoutAllV1(): CancelablePromise<{
        success?: boolean;
        tokensRevoked?: number;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/authentication/logout/all',
        });
    }
    /**
     * Issue tokens for a CLI install
     * @param requestBody
     * @returns IssueCliTokensResponseDto
     * @throws ApiError
     */
    public static authenticationControllerIssueCliTokensV1(
        requestBody: IssueCliTokensDto,
    ): CancelablePromise<IssueCliTokensResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/authentication/cli/issue-tokens',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns MyUserDto
     * @throws ApiError
     */
    public static authenticationControllerMeV1(): CancelablePromise<MyUserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/authentication/me',
        });
    }
}
